module.exports = BrowserFS.BFSRequire('process');



//////////////////
// WEBPACK FOOTER
// ./~/browserfs/dist/shims/process.js
// module id = 3
// module chunks = 0